import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  applicationSummary: {
    applicationName: '',
    archetypeCode: '',
    riskTier: '',
  },
  trustWeights: {},
  risks: [],
  metrics: [],
  useCases: [],
  loading: false,
  error: null,
};

const metricsSlice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {
    setApplicationSummary: (state, action) => {
      state.applicationSummary = { ...state.applicationSummary, ...action.payload };
    },
    setTrustWeights: (state, action) => {
      state.trustWeights = action.payload;
    },
    setRisks: (state, action) => {
      state.risks = action.payload;
    },
    setMetrics: (state, action) => {
      state.metrics = action.payload;
    },
    addMetric: (state, action) => {
      state.metrics.push(action.payload);
    },
    updateMetric: (state, action) => {
      const { index, data } = action.payload;
      state.metrics[index] = { ...state.metrics[index], ...data };
    },
    removeMetric: (state, action) => {
      state.metrics = state.metrics.filter((_, index) => index !== action.payload);
    },
    setUseCases: (state, action) => {
      state.useCases = action.payload;
    },
    setMetricsData: (state, action) => {
      return { ...state, ...action.payload, loading: false, error: null };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetMetrics: () => initialState,
  },
});

export const {
  setApplicationSummary,
  setTrustWeights,
  setRisks,
  setMetrics,
  addMetric,
  updateMetric,
  removeMetric,
  setUseCases,
  setMetricsData,
  setLoading,
  setError,
  resetMetrics,
} = metricsSlice.actions;

export default metricsSlice.reducer;
